// Copyright (c) 2016 Deere & Company

import FileList, {getDefaultState as getFileList} from '../state/files-list';
import actions from '../../actions-list';

const setRgaFileDetails = (state, action) =>
    FileList.update(state, {
        $set: action.files
    });

export default (state = getFileList(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_FILE_DETAILS]: setRgaFileDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/file.js